import http from '@/communication/AuthConnection'
import moment from 'moment'

export default async (pData) => {
  const payload = JSON.parse(JSON.stringify(pData))
  payload.date.created = new Date()
  payload.date.event = payload.date.event ? moment(payload.date.event, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : new Date()
  payload.date.deadline = payload.date.deadline ? moment(payload.date.deadline, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : payload.date.event
  try {
    const responsePayload = await http.post('/v1/event', payload)
    return responsePayload.data
  } catch (e) {
    return Promise.reject(new Error('ok'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/event/NewEvent.js